import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateProjectItemResult = { item: '_item' };
var _bulkCreateProjectItemsRequest = { items: '_item' };
var _bulkCreateProjectItemsResponse = {
    results: '_bulkCreateProjectItemResult',
};
var _bulkDeleteProjectItemsRequest = {};
var _bulkDeleteProjectItemsResponse = {};
var _bulkUpdateProjectItemResult = { item: '_item' };
var _bulkUpdateProjectItemsRequest = { items: '_maskedItem' };
var _bulkUpdateProjectItemsResponse = {
    results: '_bulkUpdateProjectItemResult',
};
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _createProjectItemRequest = { item: '_item' };
var _createProjectItemResponse = { item: '_item' };
var _deleteProjectItemRequest = {};
var _deleteProjectItemResponse = {};
var _duplicateProjectItemsRequest = {};
var _duplicateProjectItemsResponse = {};
var _generateTokenForProjectItemsRequest = {};
var _generateTokenForProjectItemsResponse = {};
var _getProjectItemRequest = {};
var _getProjectItemResponse = { item: '_item' };
var _image = {
    imageInfo: '_commonImage',
    focalPoint: '_point',
    unsharpMasking: '_unsharpMasking',
};
var _item = {
    sortOrder: 'google.protobuf.DoubleValue',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    image: '_image',
    video: '_video',
};
var _listProjectItemsRequest = {};
var _listProjectItemsResponse = { items: '_item' };
var _maskedItem = { fieldMask: 'google.protobuf.FieldMask', item: '_item' };
var _point = { x: 'DOUBLE', y: 'DOUBLE' };
var _queryProjectItemsRequest = {};
var _queryProjectItemsResponse = { items: '_item' };
var _unsharpMasking = {
    amount: 'google.protobuf.FloatValue',
    radius: 'google.protobuf.FloatValue',
    threshold: 'google.protobuf.FloatValue',
};
var _updateProjectItemRequest = {
    mask: 'google.protobuf.FieldMask',
    item: '_item',
};
var _updateProjectItemResponse = { item: '_item' };
var _video = { videoInfo: '_videoV2' };
var _videoResolution = { poster: '_commonImage' };
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_commonImage',
};
function resolveComWixpressPortfolioPortfolioappMediaServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/portfolio/v1/settings',
                destPath: '/api/v1/portfolio/settings',
            },
            {
                srcPath: '/portfolio/portfolio-app/api/v1/portfolio/settings',
                destPath: '/api/v1/portfolio/settings',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/portfolio/project/items/media',
                destPath: '/api/v1/portfolio/project/items/media',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/portfolio/portfolio-app/api/v1/portfolio/settings',
                destPath: '/api/v1/portfolio/settings',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/portfolio/project/items/media',
                destPath: '/api/v1/portfolio/project/items/media',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/create',
                destPath: '/api/v1/bulk/portfolio/items/create',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/items/duplicate',
                destPath: '/api/v1/items/duplicate',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/delete',
                destPath: '/api/v1/bulk/portfolio/items/delete',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/update',
                destPath: '/api/v1/bulk/portfolio/items/update',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/create',
                destPath: '/api/v1/bulk/portfolio/items/create',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/items/duplicate',
                destPath: '/api/v1/items/duplicate',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/delete',
                destPath: '/api/v1/bulk/portfolio/items/delete',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/update',
                destPath: '/api/v1/bulk/portfolio/items/update',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/project-items-service',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/portfolio/v1/projectItems',
                destPath: '/api/v1/portfolio/projects',
            },
            {
                srcPath: '/portfolio/v1/items',
                destPath: '/api/v1/portfolio/items',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/create',
                destPath: '/api/v1/bulk/portfolio/items/create',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/items/duplicate',
                destPath: '/api/v1/items/duplicate',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/delete',
                destPath: '/api/v1/bulk/portfolio/items/delete',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/update',
                destPath: '/api/v1/bulk/portfolio/items/update',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/portfolio/items',
                destPath: '/api/v1/portfolio/items',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/portfolio/projects',
                destPath: '/api/v1/portfolio/projects',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/project-items-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a project item. */
export function createProjectItem(payload) {
    var _a = serializer(_createProjectItemRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProjectItemResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createProjectItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.CreateProjectItem',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/portfolio/items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProjectItem.fromReq = fromReq;
    __createProjectItem.__isAmbassador = true;
    return __createProjectItem;
}
/** Creates multiple project items. */
export function bulkCreateProjectItems(payload) {
    var _a = serializer(_bulkCreateProjectItemsRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateProjectItemsResponse, {
        _bulkCreateProjectItemResult: _bulkCreateProjectItemResult,
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.BulkCreateProjectItems',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/bulk/portfolio/items/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateProjectItems.fromReq = fromReq;
    __bulkCreateProjectItems.__isAmbassador = true;
    return __bulkCreateProjectItems;
}
/** Retrieves a project item. */
export function getProjectItem(payload) {
    var _a = serializer(_getProjectItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProjectItemResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getProjectItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.GetProjectItem',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/portfolio/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                        protoPath: '/api/v1/portfolio/items/{itemId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getProjectItem.fromReq = fromReq;
    __getProjectItem.__isAmbassador = true;
    return __getProjectItem;
}
/** Retrieves a list of all project items in the specified project. */
export function listProjectItems(payload) {
    var _a = serializer(_listProjectItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listProjectItemsResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.ListProjectItems',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/portfolio/projects/{projectId}/items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listProjectItems.fromReq = fromReq;
    __listProjectItems.__isAmbassador = true;
    return __listProjectItems;
}
/**
 * Query Collections using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
 * supported only by projectId & id
 * internal usage only - should not be used, created for auto-db-driver only
 */
export function queryProjectItems(payload) {
    var _a = serializer(_queryProjectItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProjectItemsResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.QueryProjectItems',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/portfolio/items/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProjectItems.fromReq = fromReq;
    __queryProjectItems.__isAmbassador = true;
    return __queryProjectItems;
}
/** Updates a project item. */
export function updateProjectItem(payload) {
    var _a = serializer(_updateProjectItemRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProjectItemResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateProjectItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'PATCH',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.UpdateProjectItem',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/portfolio/items/{item.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProjectItem.fromReq = fromReq;
    __updateProjectItem.__isAmbassador = true;
    return __updateProjectItem;
}
/** Updates multiple project items. */
export function bulkUpdateProjectItems(payload) {
    var _a = serializer(_bulkUpdateProjectItemsRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _maskedItem: _maskedItem,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProjectItemsResponse, {
        _bulkUpdateProjectItemResult: _bulkUpdateProjectItemResult,
        _commonImage: _commonImage,
        _image: _image,
        _item: _item,
        _point: _point,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkUpdateProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'PATCH',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.BulkUpdateProjectItems',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/bulk/portfolio/items/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProjectItems.fromReq = fromReq;
    __bulkUpdateProjectItems.__isAmbassador = true;
    return __bulkUpdateProjectItems;
}
/** Deletes a project item. */
export function deleteProjectItem(payload) {
    var _a = serializer(_deleteProjectItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteProjectItemResponse, {}).fromJSON;
    function __deleteProjectItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'DELETE',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.DeleteProjectItem',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/portfolio/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteProjectItem.fromReq = fromReq;
    __deleteProjectItem.__isAmbassador = true;
    return __deleteProjectItem;
}
/** Deletes multiple project items. */
export function bulkDeleteProjectItems(payload) {
    var _a = serializer(_bulkDeleteProjectItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteProjectItemsResponse, {}).fromJSON;
    function __bulkDeleteProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'DELETE',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.BulkDeleteProjectItems',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/bulk/portfolio/items/delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteProjectItems.fromReq = fromReq;
    __bulkDeleteProjectItems.__isAmbassador = true;
    return __bulkDeleteProjectItems;
}
/**
 * Duplicates project items from one project (the origin) to another project (the target).
 *
 * <blockquote class="important">
 * <strong>Important:</strong>
 *
 * Both the origin and target projects must exist before calling this method.
 * </blockquote>
 */
export function duplicateProjectItems(payload) {
    var _a = serializer(_duplicateProjectItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_duplicateProjectItemsResponse, {}).fromJSON;
    function __duplicateProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projectitems.ProjectItemsService.DuplicateProjectItems',
            url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
                protoPath: '/api/v1/items/duplicate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __duplicateProjectItems.fromReq = fromReq;
    __duplicateProjectItems.__isAmbassador = true;
    return __duplicateProjectItems;
}
/** Generate media token for project items */
export function generateTokenForProjectItems(payload) {
    var _a = serializer(_generateTokenForProjectItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateTokenForProjectItemsResponse, {}).fromJSON;
    function __generateTokenForProjectItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.project_items.v1.project_item',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.portfolioapp.MediaService.GenerateTokenForProjectItems',
            url: resolveComWixpressPortfolioPortfolioappMediaServiceUrl({
                protoPath: '/api/v1/portfolio/project/items/media',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateTokenForProjectItems.fromReq = fromReq;
    __generateTokenForProjectItems.__isAmbassador = true;
    return __generateTokenForProjectItems;
}
//# sourceMappingURL=http.impl.js.map